import {
  Row,
  Col,
  Form,
  DatePicker,
  Radio,
  Button,
  ConfigProvider,
} from "antd";
import SelectActorType from "./Elements/Select-Actor-Type";
import SelectCities from "./Elements/Select-Cities";
import { useEffect, useState } from "react";
import store from "../../../controllers/store";
import { analytics } from "../../../controllers/store/actions/analytics/get-analytics-actions";
import { Query } from "../..";
import "dayjs/locale/zh-cn";
import dayjs from "dayjs";
interface Props {
  onSelectCitiesChange: (value: any) => void;
  onClearActorType: () => void;
  onClearCity: () => void;
}

const query = { filter: {} } as Query;
const dispatch = store.dispatch;
const AnalyticForm = (props: Props) => {
  const [form] = Form.useForm();
  const [requestType, setRequestType] = useState<string>("consumer");

  useEffect(() => {
    form.setFieldsValue({
      start: dayjs().startOf("month"),
      end: dayjs().endOf("month"),
    });

    getdata();
  }, [form]);

  const getdata = async () => {
    const values = await form.getFieldsValue();
    if (values.actor) {
      query.filter.actor = `&filter[actor_type][_eq]=${values.actor.value}`;
    }

    if (values.requestType) {
      query.filter.request_type = `&filter[request_type][_eq]=${values.requestType}`;
    }

    if (values.city) {
      query.filter.city = `&filter[cityRaw][_icontains]=${values.city.label}`;
    }

    if (values.start) {
      query.filter.start = `&filter[date_created][_gte]=${dayjs(
        values.start
      ).format("YYYY-MM-DD")}`;
    }

    if (values.end) {
      query.filter.end = `&filter[date_created][_lte]=${dayjs(
        values.end
      ).format("YYYY-MM-DD")}`;
    }

    dispatch(analytics(query));
  };

  return (
    <>
      <Form form={form} layout="vertical" name="newAnnouncement">
        <Row gutter={[8, 8]} style={{ width: "100%" }}>
          <Col xs={24} sm={12} md={6} lg={4}>
            <Form.Item
              label="Actor"
              name="actor"
              rules={[
                { required: true, message: "Por favor seleccione el actor." },
              ]}
            >
              <SelectActorType
                placeholder={"Actor"}
                onClear={() => {
                  props.onClearActorType();
                }}
                style={{ width: "100%" }}
                size="large"
                onChange={(selected: any) => {
                  form.setFieldValue("actor", selected);
                }}
              />
            </Form.Item>
          </Col>
          <Col span={12} xs={24} sm={12} md={6} lg={4}>
            <Form.Item
              label="Ciudad"
              name="city"
              rules={[
                { required: true, message: "Por favor seleccione la ciudad" },
              ]}
            >
              <SelectCities
                style={{ width: "100%" }}
                placeholder="Ciudad"
                size="large"
                onChange={(selected: string) => {
                  form.setFieldValue("city", selected);
                }}
                onClear={() => {
                  dispatch(analytics(query));
                }}
              />
            </Form.Item>
          </Col>
          <Col xs={24} sm={12} md={6} lg={4}>
            <Form.Item
              label="Fecha Inicial"
              name="start"
              rules={[
                {
                  required: true,
                  message: "Por favor ingrese la fecha inicial",
                },
              ]}
            >
              <DatePicker
                value={dayjs(new Date())}
                format={"YYYY-MM-DD"}
                style={{ width: "100%" }}
                size="large"
                placeholder="Fecha Inicial"
              />
            </Form.Item>
          </Col>
          <Col xs={24} sm={12} md={6} lg={4}>
            <Form.Item
              label="Fecha final"
              name="end"
              rules={[
                { required: true, message: "Por favor ingrese la fecha final" },
              ]}
            >
              <DatePicker
                value={dayjs()}
                format={"YYYY-MM-DD"}
                style={{ width: "100%" }}
                size="large"
                placeholder="Fecha final"
              />
            </Form.Item>
          </Col>
          <Col xs={24} sm={12} md={6} lg={8} className="flex flex-centered">
            <Form.Item
              style={{ display: "flex" }}
              label="Tipo de conexión"
              name="requestType"
              initialValue={"consumer"}
              rules={[
                { required: true, message: "Por favor ingrese la fecha final" },
              ]}
            >
              <Radio.Group>
                <Radio value="consumer">Consumidor de conocimiento</Radio>
                <Radio value="provider">Proveedor de conocimiento</Radio>
              </Radio.Group>
            </Form.Item>
            <Button
              type="primary"
              onClick={async () => {
                getdata();
              }}
            >
              Buscar
            </Button>
          </Col>
        </Row>
      </Form>
    </>
  );
};

export default AnalyticForm;
